module.exports = __webpack_public_path__ + "static/img/10.3c39c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/10.png
// module id = NS4g
// module chunks = 0